import { initViewportUnits } from './viewport.ts';
import { initCountdown } from './countdown.ts';
import { initDataTrail } from './dataTrail.ts';
import { initHero } from './hero.ts';
import { initializeLocalization } from './localization.ts';
import { initPersonalNote } from './personalNote.ts';
import { initPopup } from './popup.ts';
import { initSlidePanel } from './slidePanel.ts';
import { initSlides } from './slides.ts';
import { initComments } from './comments.ts';
import { initHooked } from './hooked.ts';
import { initLangSwitch } from './langSwitch.ts';
import { initProgressTracker } from './progress.ts';
import { initTricks } from './tricks.ts';
import { initAnalytics, trackButtonClick } from './analytics.ts';
import { initIOSDetection } from './ios-detector.ts';

async function bootstrap(): Promise<void> {
  // Initialize iOS detection first to add appropriate classes
  initIOSDetection();

  initAnalytics();
  initViewportUnits();
  try {
    await initializeLocalization();
  } catch (err) {
    console.error('Localization failed', err);
  }

  initHero();
  initSlides();
  initProgressTracker();
  initCountdown();
  initPopup();
  initSlidePanel();
  initPersonalNote();
  initDataTrail();
  initComments();
  initHooked();
  initLangSwitch();
  initTricks();

  // Track button clicks
  document.addEventListener('click', (event: MouseEvent) => {
    if (!event.target) return;
    const button = (event.target as HTMLElement).closest('button');
    if (!button) return;

    let buttonType: string = 'unknown';
    const properties: Record<string, string | null> = {};

    if (button.hasAttribute('data-panel-id')) {
      buttonType = 'cta_panel';
      properties.panel_id = button.getAttribute('data-panel-id');
    } else if (button.classList.contains('scroll-indicator')) {
      buttonType = 'scroll_indicator';
    } else if (button.hasAttribute('data-i18n')) {
      buttonType = button.getAttribute('data-i18n') || 'unknown';
    } else if (button.id) {
      buttonType = button.id;
    } else if (button.classList.contains('hooked-stage-option')) {
      buttonType = 'hooked_stage_option';
      properties.stage_id = button.getAttribute('data-stage');
    }

    trackButtonClick(buttonType, properties);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
